/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { dailyStatsGetApiV3DailyStatsMaxTotalTransactionsPerSecTillDate } from "../../funcs/dailyStatsGetApiV3DailyStatsMaxTotalTransactionsPerSecTillDate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3DailyStatsMaxTotalTransactionsPerSecTillDateRequest$inboundSchema
    .optional(),
};

export const tool$dailyStatsGetApiV3DailyStatsMaxTotalTransactionsPerSecTillDate:
  ToolDefinition<typeof args> = {
    name:
      "daily-get-api-v3-stats-max-total-transactions-per-sec-till-date",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await dailyStatsGetApiV3DailyStatsMaxTotalTransactionsPerSecTillDate(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
